import { styled } from '@linaria/react';
import { colors, fonts } from '../theme/tokens';

export const IconWrapper = styled.span`
  position: relative;
  display: inline-flex;
`;

export const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  background: ${colors.primary};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.bold};
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  line-height: 1;
`;
